export default __webpack_public_path__ + "f20a55f3977d677877fdfba2c7b1a9e0.svg";